import { WIDGET_STATUS } from '@/utils/support-widget-bridge';

const isReady = (state) => state.status === WIDGET_STATUS.READY;

export default {
  /** O chat embutido autenticou: o menu "Suporte" abre o painel em vez do portal. */
  isAvailable(state) {
    return isReady(state);
  },

  isOpen(state) {
    return isReady(state) && state.open;
  },

  unread(state) {
    return state.unread;
  },

  attention(state) {
    return state.attention;
  },

  /** Conversas com resposta nao lida mais os avisos pendentes: o numero do selo. */
  pending(state) {
    return isReady(state) ? state.unread + state.attention : 0;
  },

  isLauncherVisible(state) {
    return isReady(state) && state.summoned && !state.open;
  },

  request(state) {
    return state.request;
  }
};
